import { language } from "@chef/constants";
export const intl = (
  {
    no: {
      EDIT_ADDRESS: "Rediger adresse",
      GENERIC_UPDATE_ADDRESS_ERROR:
        "Adressen kunne dessverre ikke opdateres. Kontakt kundeservice, hvis problemet fortsetter",
      REMOVE_ADDRESS: "Fjern adressen",
      ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ADDRESS:
        "Er du sikker på at du vil fjerne adressen?",
      THE_ACTION_CANNOT_BE_UNDONE: "Handlingen kan ikke angres",
      CANCEL: "Avbryt",
    },
    se: {
      EDIT_ADDRESS: "Redigera adress",
      GENERIC_UPDATE_ADDRESS_ERROR:
        "Kunde tyvärr inte uppdatera adressen. Prova igen, eller kontakta kundtjänst!",
      REMOVE_ADDRESS: "Ta bort adress",
      ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ADDRESS:
        "Är du säker på att du vill ta bort adressen?",
      THE_ACTION_CANNOT_BE_UNDONE: "Åtgärden kan inte ångras",
      CANCEL: "Avbryt",
    },
    dk: {
      EDIT_ADDRESS: "Rediger adresse",
      GENERIC_UPDATE_ADDRESS_ERROR:
        "Adressen kunne desværre ikke opdateres. Kontakt support, hvis problemet fortsætter",
      REMOVE_ADDRESS: "Slet adresse",
      ARE_YOU_SURE_YOU_WANT_TO_REMOVE_ADDRESS:
        "Er du sikker på, at du vil slette denne adresse?",
      THE_ACTION_CANNOT_BE_UNDONE: "Denne handling kan ikke annulleres",
      CANCEL: "Annuller",
    },
  } as const
)[language];
